module.exports = __webpack_public_path__ + "static/media/notification-svgrepo-com (1).aa53e911.svg";